export default "__VITE_ASSET__PHEP9gVN__"